export class ComplementPoPdfVer {
    static jsonMap = {
        idProducteurOrganise: { key: 'idProducteurOrganise' },
        idContactReferent: { key: 'idContactReferent', optional: true },
        structureJuridique: { key: 'structureJuridique', optional: true, default: '' }
    };

    public idProducteurOrganise: number;
    public idContactReferent: number;
    public structureJuridique: string;
}
